/**
 * How far (px) a pointer may move between press and release and still count as a click, not a
 * drag. One value for the viewers' icon clicks (labels3dExt) and the 360 mini map.
 */
export const CLICK_MOVE_TOLERANCE_PX = 6;
